import { MOBILITY_API_URL } from 'constants/ApiConstants';
import { INTERVENTIONS_API_URL } from 'constants/InterventionConstants';
import { TECHNICIAN } from 'constants/ModeConstants';
import type { PageContent } from 'modules/global/generic.types';
import * as actionTypes from 'modules/interventions/actionTypes';

import type * as types from '../types/actions';
import type { MobilityIntervention } from '../types/projections/mobility-intervention';
import type { InterventionsMobilityQsRequest } from '../types/requests/interventions-mobility-qs-request';

// ENTRIES

export const getMobilityEntries = (
  params: InterventionsMobilityQsRequest,
  meta: Record<string, unknown> = {},
): types.GetMobilityEntriesAction => ({
  type: actionTypes.FETCH_MOBILITY_INTERVENTIONS,
  payload: {
    request: {
      method: 'GET',
      url: `${INTERVENTIONS_API_URL[TECHNICIAN]}/mobility`,
      params,
    },
  },
  meta,
});

export const getMobilityEntriesSuccess = (
  data: PageContent<MobilityIntervention>,
  meta: Record<string, unknown> = {},
): types.GetMobilityEntriesSuccessAction => ({
  type: actionTypes.FETCH_MOBILITY_INTERVENTIONS_SUCCESS,
  payload: data,
  meta,
});

export const getMobilityEntriesFailure = (
  error: string,
  meta: Record<string, unknown> = {},
): types.GetMobilityEntriesFailureAction => ({
  type: actionTypes.FETCH_MOBILITY_INTERVENTIONS_FAILURE,
  payload: error,
  error: true,
  meta,
});

// FETCH/UPDATE OPERATIONS

export const fetchMobility = (mobilityId: string, meta: Record<string, unknown> = {}): types.FetchMobilityAction => ({
  type: actionTypes.FETCH_MOBILITY_ITEM,
  payload: {
    request: {
      method: 'GET',
      url: `${MOBILITY_API_URL}/${mobilityId}`,
      params: {
        projection: 'details',
      },
    },
    mobilityId,
  },
  meta,
});

export const fetchMobilitySuccess = (
  mobility: import('modules/selfServices/types').Mobility,
  meta: Record<string, unknown> = {},
): types.FetchMobilitySuccessAction => ({
  type: actionTypes.FETCH_MOBILITY_ITEM_SUCCESS,
  payload: mobility,
  meta,
});

export const fetchMobilityFailure = (
  error: string,
  meta: Record<string, unknown> = {},
): types.FetchMobilityFailureAction => ({
  type: actionTypes.FETCH_MOBILITY_ITEM_FAILURE,
  payload: error,
  error: true,
  meta,
});

export const updateMobility = (
  mobility: import('modules/selfServices/types').Mobility,
  meta: Record<string, unknown> = {},
): types.UpdateMobilityAction => ({
  type: actionTypes.UPDATE_MOBILITY_ITEM,
  payload: {
    request: {
      method: 'PUT',
      url: `${MOBILITY_API_URL}/${mobility.id}`,
      data: mobility,
    },
  },
  meta,
});

export const updateMobilitySuccess = (
  mobility: import('modules/selfServices/types').Mobility,
  meta: Record<string, unknown> = {},
): types.UpdateMobilitySuccessAction => ({
  type: actionTypes.UPDATE_MOBILITY_ITEM_SUCCESS,
  payload: mobility,
  meta,
});

export const updateMobilityFailure = (
  error: string,
  meta: Record<string, unknown> = {},
): types.UpdateMobilityFailureAction => ({
  type: actionTypes.UPDATE_MOBILITY_ITEM_FAILURE,
  payload: error,
  error: true,
  meta,
});

// DASHBOARD

export const removeFromDashboard = (
  interventionId: string,
  meta: Record<string, unknown> = {},
): types.RemoveMobilityInterventionAction => ({
  type: actionTypes.REMOVE_MOBILITY_INTERVENTION,
  payload: interventionId,
  meta,
});
